module.exports = __webpack_public_path__ + "img/DGMED.47f7a634.png";